import axios from 'axios'
import {Store} from 'vuex'
import VueRouter from 'vue-router'
import TranslationService from '@/locale/translation.service'

export default class AccountService {
  constructor(private store: Store<any>, private translationService: TranslationService, private cookie: any, private router: VueRouter) {
    this.init()
  }

  public init(): void {
    this.retrieveProfiles()
  }

  public retrieveProfiles(): Promise<boolean> {
    return new Promise((resolve) => {
      axios
        .get('management/info')
        .then((res) => {
          if (res.data && res.data.activeProfiles) {
            this.store.commit('setRibbonOnProfiles', res.data['display-ribbon-on-profiles'])
            this.store.commit('setActiveProfiles', res.data.activeProfiles)
          }
          resolve(true)
        })
        .catch(() => resolve(false))
    })
  }

  public retrieveAccount(): Promise<boolean> {
    return new Promise((resolve) => {
      axios
        .get('api/account')
        .then((response) => {
          this.store.commit('authenticate')
          const account = response.data

          if (account) {
            this.store.commit('authenticated', account)
            if (this.store.getters.currentLanguage !== account.langKey) {
              this.store.commit('currentLanguage', account.langKey)
            }
            if (sessionStorage.getItem('requested-url')) {
              this.router.replace(sessionStorage.getItem('requested-url'))
              sessionStorage.removeItem('requested-url')
            }
          } else {
            this.store.commit('logout')
            this.router.push('/')
            sessionStorage.removeItem('requested-url')
          }
          this.translationService.refreshTranslation(this.store.getters.currentLanguage)
          resolve(true)
        })
        .catch(() => {
          this.store.commit('logout')
          resolve(false)
        })
    })
  }

  public hasAnyAuthorityAndCheckAuth(authorities: any): Promise<boolean> {
    let authoritiesToCheck = authorities

    if (typeof authorities === 'string') {
      authoritiesToCheck = [authoritiesToCheck]
    }

    if (this.authenticated && !this.userAuthorities) {
      if (!this.store.getters.account) {
        return this.retrieveAccount().then((resp) => {
          if (resp) {
            return this.checkAuthorities(authoritiesToCheck)
          }
          return Promise.resolve(false)
        })
      }
      return Promise.resolve(false)
    }

    return this.checkAuthorities(authorities)
  }

  private checkAuthorities(authorities: any): Promise<boolean> {
    if (!authorities) {
      // route non sécurisée
      return Promise.resolve(true)
    }
    if (this.userAuthorities) {
      for (const authority of authorities) {
        if (this.userAuthorities.includes(authority)) {
          return Promise.resolve(true)
        }
      }
    }
    return Promise.resolve(false)
  }

  public get authenticated(): boolean {
    return this.store.getters.isAuthenticated
  }

  public get connectedUser(): any {
    return this.authenticated ? this.store.getters.account : null
  }

  public get userAuthorities(): any {
    return this.store.getters.account ? this.store.getters.account.authorities : null
  }

  public isAuthorizedToIHM(): Promise<boolean> {
    return this.checkIfIsAuthorized('api/isAuthorizedToIHM', 'authorizedIhm')
  }

  public isAuthorizedToPTDDT(): Promise<boolean> {
    return this.checkIfIsAuthorized('api/isAuthorizedToPTDDT', 'authorizedPtddt')
  }

  private checkIfIsAuthorized(urlEndpoint, mutation): Promise<boolean> {
    return new Promise((resolve) => {
      axios
        .get<any>(urlEndpoint)
        .then((res) => {
          if (res.data === true) {
            this.store.commit(mutation)
          }
          resolve(true)
        })
        .catch(() => resolve(false))
    })
  }
}
